import React from 'react';
import { BedIcon, ClipboardListIcon, LockIcon, MicroscopeIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Card, CardBody } from '../Card';
import { CtaButton } from '../CtaButton';
const STEPS = [{
  icon: ClipboardListIcon,
  day: 'Day 1',
  title: '3D Facial Design',
  body: 'Arrival, clinical records, CBCT, intraoral scan, and smile design mapped to your own face. Before any surgery, you know exactly how it will look. No surprises.'
}, {
  icon: MicroscopeIcon,
  day: 'Day 2',
  title: 'Guided Surgery Under Sedation',
  body: 'The Dadeland clinical team places four to six premium implants with a printed surgical guide, never freehand. You leave with an esthetic provisional smile for the rest of your trip.'
}, {
  icon: BedIcon,
  day: 'Days 3 and 4',
  title: 'Accompanied Recovery',
  body: 'You rest, attend post procedure checkups, and receive initial adjustments. Your hotel is ten minutes from Dadeland, and the clinical team calls daily to monitor your progress.'
}, {
  icon: SparklesIcon,
  day: 'Day 5',
  title: 'Your Final Zirconia Prosthesis',
  body: 'You receive your final zirconia bridge with a custom esthetic micro layer. Its translucency, texture, and shade are matched to your facial anatomy. Then you fly home with a smile that no longer needs filters.'
}];
export function Mechanism() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-104" data-mp="2bq6v5sry2enz">
      <div className="mx-auto max-w-6xl px-6" data-id="element-105" data-mp="2bpoqc7r7us4g">
        <SectionHeading eyebrow="Exactly what happens in those five days" title={<><span data-id="element-107" data-mp="2gmoz4qfga8z9">This is not &ldquo;teeth in a day.&rdquo; </span><span className="text-[#1F6E7B]" data-id="element-108" data-mp="2lh1iz1ku9mbj">It is your final smile in 5 days.</span></>} data-id="element-106" data-mp="2goi5s5q2ct79">
          <p data-id="element-109" data-mp="2phliucwsr41d">Pler Smile Dadeland built a four step protocol that price driven clinics and speed driven clinics cannot replicate.</p>
        </SectionHeading>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-110" data-mp="2uelm6g29hsos">
          {STEPS.map((step, i) => {
          const Icon = step.icon;
          return <Card key={step.day} className="h-full" data-id="element-111" data-mp="zdtacg6feyiq" data-mpi={i}>
                <CardBody className="flex h-full flex-col" data-id="element-112" data-mp="ueglxqzwpje1">
                  <div className="mb-5 flex items-center justify-between" data-id="element-113" data-mp="uc3xcuzn8as0">
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#A9DFE9]/40 text-[#1F6E7B]" data-id="element-114" data-mp="193uz7a6lskyp"><Icon size={24} data-id="element-115" data-mp="14as3owi9n1fv" /></span>
                    <span className="text-sm font-bold uppercase tracking-wide text-[#26B3CA]" data-id="element-116" data-mp="1i3rggqqnyhjq">Step {i + 1}</span>
                  </div>
                  <div className="text-sm font-semibold uppercase tracking-wide text-[#1A1A2E]/60" data-id="element-117" data-mp="1e14n2lecgokf">{step.day}</div>
                  <h3 className="mt-1 text-xl font-bold text-[#1A1A2E]" data-id="element-118" data-mp="1s1fcrl3x3x40">{step.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#1A1A2E]/80" data-id="element-119" data-mp="1n45r8gjng5lg">{step.body}</p>
                </CardBody>
              </Card>;
        })}
        </div>

        <figure className="mx-auto mt-16 max-w-3xl text-center" data-id="element-120" data-mp="3ouqy7o4js3o2">
          <blockquote className="text-2xl font-bold leading-snug text-[#1A1A2E] md:text-3xl" data-id="element-121" data-mp="3owbvvmm5s2q5">
            “We offers the only smile that actually belongs on your face.”
          </blockquote>
        </figure>

        <div className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl bg-[#A9DFE9]/25 p-6 text-[15px] leading-relaxed text-[#1A1A2E]/85" data-id="element-122" data-mp="29d44icrmumeh">
          <LockIcon size={20} className="mt-0.5 shrink-0 text-[#1F6E7B]" data-id="element-123" data-mp="1zk5gaw01sxve" />
          <p data-id="element-124" data-mp="1ll5qvm4poey6">
            Only <span className="font-semibold text-[#1A1A2E]" data-id="element-125" data-mp="1lknkhwoc4kcj">10 new cases per month</span> access the
            <span className="font-semibold text-[#1A1A2E]" data-id="element-126" data-mp="1qltdzwptkbn4"> 5-Day Smile Experience Program</span> in Dadeland.
            This limit is clinical, not commercial. Every case requires exclusive booking of the surgical team.
          </p>
        </div>

        <div className="mt-9 flex flex-col items-center" data-id="element-127" data-mp="1gofasyswpjcr">
          <CtaButton label="Reserve My Free Consultation" data-id="element-128" data-mp="362tw194puo3i" />
          <p className="mt-3 text-sm font-medium text-[#1A1A2E]/70" data-id="element-129" data-mp="3b0ddehwpngzo">You can confirm eligibility before traveling.</p>
        </div>
      </div>
    </section>;
}